export interface Message {
    id: number;
    name: string;
    subject: string;
    body: string;
    date: string;
    sendingUserId: number;
    isRead: boolean;
    source: string;
    applicantId?: number | undefined;
}

export enum MessageType {
    Received,
    Sent
}
